import hgpEditAddress from './main';

export default {
  install(Vue) {
    Vue.component(hgpEditAddress.name, hgpEditAddress);
  },
};

